import React, { useState } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import Dropzone from 'react-dropzone';
import { ProgressBar } from 'react-bootstrap';

import Target from './target';

import './styles.scss';

export default function BuildoutDropzone({ className, placeholder, upload, onSuccess }) {
  const [progress, setProgress] = useState();
  const [uploading, setUploading] = useState();

  async function handleUpload(files) {
    if (files.length === 0) {
      return;
    }

    setProgress(0);
    setUploading(true);

    const uploadEvents = [];
    const uploads = files.map((file, i) => {
      function onUploadProgress(event) {
        uploadEvents[i] = event;

        let totalProgress = 0;
        let totalSize = 0;
        for (const progress of Object.values(uploadEvents)) {
          totalProgress += progress.loaded;
          totalSize += progress.total;
        }

        setProgress(Math.floor(totalProgress * 100 / totalSize));
      }

      return upload(file, { onUploadProgress }).then(onSuccess);
    });

    await Promise.all(uploads);
    setUploading(false);
  }

  return (
    <Dropzone onDrop={handleUpload}>
      {({ getRootProps, getInputProps }) => (
        <div className={classNames('buildout-dropzone clickable text-center', className)} {...getRootProps()}>
          {uploading
            ? <ProgressBar active now={progress} />
            : (placeholder || <Target />)
          }

          <input {...getInputProps()} />
        </div>
      )}
    </Dropzone>
  );
}

BuildoutDropzone.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.node,
  upload: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};
